import { IntlShape } from 'react-intl';
import * as z from 'zod';
import { QueueRuleAction } from '@rossum/api-client/schemas';
import { actionSchema } from './actions';

export const ruleActionFormSchema = (intl?: IntlShape) =>
  z
    .object({
      id: z.string(),
      enabled: z.boolean(),
    })
    .and(actionSchema(intl));

export const ruleFormSchema = (intl: IntlShape) =>
  z.object({
    name: z.string().min(
      1,
      intl.formatMessage({
        id: 'features.queueSettings.rules.error.form.fieldRequired',
      })
    ),
    description: z.string(),
    triggerCondition: z
      .string()
      .min(
        1,
        intl.formatMessage({
          id: 'features.queueSettings.rules.error.form.fieldRequired',
        })
      )
      .max(
        2000,
        intl.formatMessage({
          id: 'features.queueSettings.rules.error.form.formulaLength',
        })
      ),
    enabled: z.boolean(),
    actions: z.array(ruleActionFormSchema(intl)),
    // Queues is here only when creating a rule
    queues: z.array(z.string()).optional(),
  });

export type ValidRuleForm = z.TypeOf<ReturnType<typeof ruleFormSchema>>;

export const extractKnownActions = <R extends { actions?: QueueRuleAction[] }>(
  rule: R
) => {
  const knownActions =
    rule.actions?.flatMap(a => {
      const _ruleActionFormSchema = ruleActionFormSchema(undefined);
      const parsedAction = _ruleActionFormSchema.safeParse(a);
      return parsedAction.success ? [parsedAction.data] : [];
    }) ?? [];

  return { ...rule, actions: knownActions };
};
